var $926a5a4bd69f255b$exports = {};
$926a5a4bd69f255b$exports = {
    "collapse": `Reduzieren`,
    "columnResizer": `Spaltenanpassung`,
    "drag": `Ziehen`,
    "expand": `Erweitern`,
    "loading": `Laden...`,
    "loadingMore": `Mehr laden ...`,
    "resizeColumn": `Spaltengr\xf6\xdfe \xe4ndern`,
    "sortAscending": `Aufsteigend sortieren`,
    "sortDescending": `Absteigend sortieren`
};


export {$926a5a4bd69f255b$exports as default};
//# sourceMappingURL=de-DE.mjs.map
